<template>
  <div class="enterporise_list">
    <div class="container">
      <el-card :body-style="{ padding: '12px 16px' }">
        <el-form label-width="100px">
          <el-form-item label="总部地址：">
            <CascaderArea
              :country="queryInfo.companyCountry"
              :province="queryInfo.companyProvince"
              :city="queryInfo.companyCity"
              @searchArae="searchArae"
              class="CascaderArea"
            />
          </el-form-item>
          <el-form-item label="合作状态：">
            <radio-select
              :code.sync="queryInfo.cooperationStatus"
              type-code="001"
              query-name="cooperationStatus"
              name="目前状态"
              @onChange="onChange"
            />
          </el-form-item>
          <el-form-item label="融资轮次：">
            <radio-select
              :code.sync="queryInfo.companyFinancingRounds"
              type-code="002"
              query-name="companyFinancingRounds"
              name="融资轮次"
              @onChange="onChange"
            />
          </el-form-item>
          <el-form-item label="成立时间：">
            <radio-select
              :code.sync="queryInfo.companyEstablishTime"
              type-code="003"
              query-name="companyEstablishTime"
              name="成立时间"
              @onChange="onChange"
            />
          </el-form-item>
          <el-form-item label="所属行业：">
            <multiSelect
              typeCode="004"
              @change="changePositionType"
              :code.sync="queryInfo.industry"
            />
          </el-form-item>
        </el-form>
      </el-card>
      <el-card style="margin-top: 12px">
        <div class="enterporise_list_input_add">
          <div class="input_new">
            <el-input
              placeholder="请输入相关企业名称"
              v-model="queryInfo.companyFullName"
              clearable
              class="input-with-select"
            >
              <el-button slot="append" @click="searchTalent" icon="el-icon-search"></el-button>
            </el-input>
          </div>
          <el-button
            type="primary"
            v-has-permission="'/company/save'"
            class="add_enterprise"
            @click="addEnterprise"
            >+新增企业</el-button
          >
        </div>
        <el-table ref="multipleTable" class="enterprise_table" :data="tableData">
          <el-table-column width="100" label="Logo" align="center">
            <template v-slot="{ row }">
              <el-image
                :src="row.companyKey"
                style="cursor: pointer; width: 48px; height: 48px"
                @click="businessDetails(row)"
                v-if="row.companyKey"
              ></el-image>
              <el-image
                :src="require('@/assets/pro.png')"
                style="cursor: pointer; width: 48px; height: 48px"
                @click="businessDetails(row)"
                v-else
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="公司名称" width="260" align="center">
            <template v-slot="{ row }">
              <div style="cursor: pointer" @click="businessDetails(row)">
                {{ row.companyFullName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="所属行业" align="center" prop="industry"></el-table-column>
          <el-table-column
            label="成立时间"
            align="center"
            prop="companyEstablishTime"
          ></el-table-column>
          <el-table-column label="企业规模" align="center" prop="enterpriseScale"></el-table-column>
          <el-table-column
            label="融资轮次"
            align="center"
            prop="companyFinancingRounds"
          ></el-table-column>
          <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
          <el-table-column label="合作状态" width="80" align="center">
            <template v-slot="{ row }">
              <div class="no_cooperation" v-if="row.cooperationStatus === '未合作'">未合作</div>
              <div class="in_cooperation" v-else-if="row.cooperationStatus === '合作中'">
                合作中
              </div>
              <div class="to_be_renewed" v-else-if="row.cooperationStatus === '待续约'">待续约</div>
            </template>
          </el-table-column>
          <el-table-column class="operation" width="100" label="操作" align="center">
            <template v-slot="{ row }">
              <div class="operation_bottom">
                <dic-button
                  @buttonClick="editItem(row)"
                  icon="icon-jr-icon-modify"
                  permission="/company/update"
                  text="编辑"
                />
                <dic-button
                  @buttonClick="deleteItem(row)"
                  icon="icon-jr-icon-delete"
                  permission="/company/deleteCompany"
                  text="删除"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div class="page_nation pagination">
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[30, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { pagination } from '@/mixins/pagination'
import CascaderArea from '@/components/CascaderArea.vue'
import { getCompanyLists, deleteCompanyId } from '@/api/enterprise.js'
import radioSelect from '@/components/RadioSelect.vue'
import multiSelect from '@/components/MultiSelect.vue'
import DicButton from '@/components/DicButton.vue'
const defaultQueryObj = Object.freeze({
  companyFullName: '', //公司全称
  companyCity: '', //所属城市
  companyCountry: '中国', //所属国家
  companyEstablishTime: '', //公司成立时间
  companyFinancingRounds: '', //公司当前融资轮次
  companyProvince: '', //所属省份
  cooperationStatus: '', //合作状态
  industry: [], //
  // order: '0', //排序
  pageNum: 0, //页数
  pageSize: 10, //大小
  size: '' //所选条数
})
export default {
  components: { DicButton, CascaderArea, radioSelect, multiSelect },
  name: 'enterpriseList',
  mixins: [pagination],
  data() {
    return {
      queryInfo: { ...defaultQueryObj },
      tableData: [] //表格数据
    }
  },
  created() {
    this.search()
  },
  methods: {
    onChange() {
      this.search()
    },
    // 查询
    searchArae(val) {
      this.queryInfo.companyCountry = val.country

      this.queryInfo.companyProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.companyCity = val.city
      }

      this.search()
    },
    //新增企业
    addEnterprise() {
      this.$router.push({
        path: '/dataManagement/addEnterprise',
        query: {
          enterpriseType: 0,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    //编辑企业
    editItem(row) {
      this.$router.push({
        path: '/dataManagement/updateEnterprise',
        query: {
          enterpriseType: 1,
          companyCode: row.companyCode,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    //删除单个企业
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await deleteCompanyId([row.companyCode])
          if (res.resultCode === 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    //点击进入详情
    businessDetails(row) {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.flatMap((item) => item.children.map((i) => i.path))
        }
      )
      const hasPermission = userPermissions.includes('/company/getCompanyBYid')
      if (hasPermission) {
        this.$router.push({
          name: 'businessDetails',
          query: {
            companyCode: row.companyCode,
            searchInfo: JSON.stringify(this.queryInfo)
          }
        })
      } else {
        this.$message.warning('暂无权限')
      }
    },
    searchTalent() {
      this.queryInfo.pageNum = 1
      this.queryInfo.pageSize = 30
      this.search()
    },
    //分页查询
    async search() {
      const { data: res } = await getCompanyLists(this.queryInfo)
      if (res.resultCode === 200) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    },
    changePositionType(data) {
      this.queryInfo.industry = data
      this.search()
    },
    //监听pagesize变化
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.search()
    },
    //监听页码变化
    handleCurrentChange(newCurrent) {
      this.queryInfo.pageNum = newCurrent
      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  max-height: 82vh;
  overflow: auto;
}
.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}

/deep/ .el-image__inner {
  border-radius: 5px;
}

/deep/ .el-input__inner {
  border-color: #17757a;
}

.el-table {
  /deep/tbody tr:hover > td {
    // background-color: #90c0f1;
    background-color: rgba(23, 117, 122, 0.1);
  }
}

.enterporise_list_input_add {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  /deep/ .input-with-select {
    width: 320px;
    margin-right: 50px;
  }
  .input_new {
    /deep/ .el-button {
      border-radius: 0 4px 4px 0;
      height: 40px;
    }

    /deep/ .el-button--default {
      background-color: #17757a;

      i {
        color: #fff;
      }
    }
  }

  .add_enterprise {
    background-color: #17757a;
    border-color: #17757a;
  }
}

.enterprise_table {
  margin-top: 20px;
  width: 100%;

  .no_cooperation {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #ffb847;
    background-color: rgba(255, 184, 71, 0.2);
    border: 1px solid #ffb847;
  }

  .in_cooperation {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #17757a;
    background-color: rgba(23, 117, 122, 0.2);
    border: 1px solid #17757a;
  }

  .to_be_renewed {
    box-sizing: border-box;
    padding: 2px 4px;
    border-radius: 4px;
    color: #4d70fa;
    background-color: rgba(77, 112, 250, 0.2);
    border: 1px solid #4d70fa;
  }

  .el_image {
    width: 48px;
    height: 48px;
    border-radius: 4px;
  }

  .operation_bottom {
    .operation_border {
      font-size: 18px;
      color: #e8e8e8;
    }
  }
}

.CascaderArea {
  /deep/ .el-input__inner {
    border: 1px solid #17757a;
    color: #17757a;
    height: 34px;
    line-height: 34px;
  }
}
/deep/ .el-form-item {
  margin-bottom: 5px;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 78vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 80vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 74vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 71vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 77vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}
</style>
